import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import { DeepReadonly } from '@src/utils/type-utils';
import React, { memo, useMemo } from 'react';
import VideoIcon from '@public/images/kol/Play-Big.svg';
import { AppLink } from '@components/common/AppLink';
import { useTranslation } from 'next-i18next';
import KolBadgeList from './kol-badge-list';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { removeflashUrl } from '@src/utils/util';
import videoStore from '@mobx/stores/video-store';
import { convertArticleInfo } from '@src/hooks/tracker/use-article-tracker';
import { ContentBlockFragment } from '@graphqlTypes/sitecore';

type Props = {
    index?: number;
    betpickDetail: DeepReadonly<BetPickDetail>;
    type: 'leader' | 'race';
    videoEnable?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    jsBridge?: any;
    contentBlock: ContentBlockFragment | null | undefined;
};

const BetPickCaption = ({
    betpickDetail,
    type,
    videoEnable = true,
    jsBridge,
    contentBlock,
}: Props) => {
    // console.log('betpickDetail==========', betpickDetail);
    const { betpick, race, raceDay } = betpickDetail;
    const profile = betpickDetail.leader;
    const { t } = useTranslation('kol');
    const videoNoNative = (type?: string) => {
        videoStore.setDefaults();
        type && videoStore.setVideoType(type);
        const kolData: any = betpick?.kol?.targetItem;
        kolData && videoStore.setkolName(kolData.name);
        contentBlock && videoStore.setVideoContentBlock(contentBlock);
        videoStore.setraceID(`${raceDay?.name}/${race?.name}`);
    };
    const videoNative = (videoNativePip: boolean, link: string) => {
        nonPageTracker(
            {
                eventID: TrackingEvent.VideoPlay,
                raceID: `${raceDay?.name}/${race?.name}`,
                kolName: betpick.kol?.targetItem?.name,
                videoURL: removeflashUrl(link ?? ''),
                eventValue: 'KOLbetpick-Betpick',
            },
            //{ article: convertArticleInfo(betpick.kol?.targetItem) }
            { article: convertArticleInfo(contentBlock) }
        );
        return jsBridge.appOpenNativePlayer(link, '', videoNativePip);
    };

    const title = useMemo(() => {
        if (type === 'leader') {
            const profileUrl = `/kol-profile/${profile?.name}/`;
            const badges =
                profile?.badges
                    .find((badge) => badge.name === 'badges')
                    ?.children.map((b) => b.badgeIconLink?.targetItem) || [];
            return (
                <div className='flex items-center'>
                    <AppLink href={profileUrl}>
                        <img
                            className='w-[35px] h-[35px] mx-1 rounded-full border-[#1F58D8] border object-cover'
                            alt=''
                            loading='lazy'
                            src={profile?.kolThumbSq?.src || ''}
                        ></img>
                    </AppLink>
                    <div className='px-2'>
                        <div className='leading-[22px]'>
                            <AppLink href={profileUrl}> {profile?.kolName?.value}</AppLink>
                            <AppLink href={profileUrl}>
                                <KolBadgeList badges={badges}></KolBadgeList>
                            </AppLink>
                        </div>

                        <span className='text-[#0234A6] text-[12px] font-bold'>
                            <AppLink href={profileUrl}>{`${profile?.score?.value || 0}${t(
                                'betpick.pts'
                            )}`}</AppLink>
                        </span>
                    </div>
                </div>
            );
        } else {
            const race = betpickDetail.race;
            if (!race || !betpickDetail.raceDay) {
                return <></>;
            }
            const url = `/betpick/${betpickDetail.raceDay.name}/${betpickDetail.race.name}/`;
            const raceNo = race.raceNo?.numberValue || 0;
            return (
                <div className='flex justify-center flex-col'>
                    <div className='leading-[18px] font-bold'>
                        <AppLink href={url}>
                            {raceNo > 0 && raceNo <= 15 && t(`race${raceNo}`)} -{` `}
                            {betpick?.betPickType?.targetItem?.betTypeName?.value}
                        </AppLink>
                    </div>
                    {/* <span className='text-[15px]'>
                        <AppLink href={url}>{race.raceInfoText?.value}</AppLink>
                    </span> */}
                </div>
            );
        }
    }, [
        betpick?.betPickType?.targetItem?.betTypeName?.value,
        betpickDetail.race,
        betpickDetail.raceDay,
        profile?.badges,
        profile?.kolName?.value,
        profile?.kolThumbSq?.src,
        profile?.name,
        profile?.score?.value,
        t,
        type,
    ]);

    return (
        <div className='flex justify-between items-center pt-[8px]'>
            <div>{title}</div>
            {videoEnable && betpick.betPickVideo?.value && (
                <div className='relative'>
                    <img
                        className='w-[70px] h-10 rounded-[7px] ml-2 video-pop object-cover'
                        loading='lazy'
                        src={betpick.betPickVideoImage?.src}
                        alt=''
                        data-poster={
                            betpick?.videoNative?.boolValue ? '' : betpick?.betPickVideo?.value
                        }
                        data-image={betpick.betPickVideoImage?.src}
                        onClick={() => {
                            betpick?.videoNative?.boolValue
                                ? videoNative(
                                      betpick?.videoNativePip?.boolValue ?? false,
                                      betpick?.betPickVideo?.value ?? ''
                                  )
                                : videoNoNative('KOLBetpick');
                        }}
                    ></img>

                    <VideoIcon className='absolute -bottom-[2px] -right-[6px]'></VideoIcon>
                </div>
            )}
        </div>
    );
};

export default memo(BetPickCaption);
